import { render, staticRenderFns } from "./ComparisonForm.vue?vue&type=template&id=f50034e0&"
import script from "./ComparisonForm.vue?vue&type=script&lang=js&"
export * from "./ComparisonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports